/**
 * ****************************************************************************
 * @description     :   Store data and process common will use in app
 * @created at      :   2022/03/24
 * @created by      :   ANS809 – quypn@ans-asia.com
 * @package         :   Frontier Consulting
 * @copyright       :   Copyright (c) A.N.S Asia
 * @version         :   1.0.0
 * ****************************************************************************
 */

import messages, { MSG_TYPE, MSG_TITLE } from '@/utils/messages';
import repository from '@/repository';
import Router from '@/router';

export default {
    namespaced: true,
    state: {
        isLoading: false,
        isForceLoading: false,
        isNoLoading: false,
        countLoading: 0,
        isShowHeaderError: false,
        isShowHalfMenu: false,
        isShowFullMenu: false,
        headerErrors: [],
        isShowModalMessage: false,
        messageCount: 0,
        modalMessage: {
            type: MSG_TYPE.ERROR,
            title: '',
            content: '',
            okText: 'はい',
            cancelText: 'いいえ',
            callback: () => {}
        },
        user: {},
        permissions: {},
        header: {
            leftButtons: [],
            showBack: false,
            onBack: () => {},
            rightButtons: [
                {
                    title: 'よくある質問',
                    icon: 'fab fa-quora fa-lg',
                    onClick: () => {}
                },
                {
                    title: '一次会社からの問い合わせ',
                    icon: 'fas fa-question fa-lg',
                    onClick: () => {}
                }
            ],
            title: ''
        },
        screenId: 'login',
        isMobile: false,
        isBgHeaderDefault: true,
        isDataScreenChange: false,
        isLogout: false,
        isLogin: false,
        menus: []
    },
    getters: {},
    mutations: {
        showLoading(state) {
            state.isLoading = true;
        },
        hideLoading(state) {
            state.isLoading = false;
        },
        showForceLoading(state) {
            state.isForceLoading = true;
        },
        hideForceLoading(state) {
            state.isForceLoading = false;
        },
        showHeaderError(state, errors) {
            state.isShowHeaderError = true;
            state.headerErrors = errors;
        },
        hideHeaderError(state) {
            state.isShowHeaderError = false;
            state.headerErrors = [];
        },
        showModalMessage(state, message) {
            state.isShowHeaderError = false;
            state.headerErrors = [];
            state.isShowModalMessage = true;
            if (message) {
                if (message.type) {
                    state.modalMessage.type = message.type;
                } else {
                    state.modalMessage.type = MSG_TYPE.ERROR;
                }
                state.modalMessage.title = message.title;
                if (message.content) {
                    state.modalMessage.content = message.content;
                } else {
                    state.modalMessage.content = messages.E999;
                }
                if (message.okText) {
                    state.modalMessage.okText = message.okText;
                } else {
                    state.modalMessage.okText = 'はい';
                }
                if (message.cancelText) {
                    state.modalMessage.cancelText = message.cancelText;
                } else {
                    state.modalMessage.cancelText = 'いいえ';
                }
                state.modalMessage.callback = message.callback;
            } else {
                state.modalMessage = {
                    type: MSG_TYPE.ERROR,
                    title: MSG_TITLE.E999,
                    content: messages.E999,
                    okText: 'はい',
                    cancelText: 'いいえ',
                    callback: () => {}
                };
            }
        },
        updateShowModalMessage(state, value) {
            state.isShowModalMessage = value;
        },
        hideModalMessage(state) {
            state.isShowModalMessage = false;
            state.modalMessage = {
                type: MSG_TYPE.ERROR,
                title: '',
                content: '',
                okText: 'はい',
                cancelText: 'いいえ',
                callback: () => {}
            };
        },
        setHeader(state, header) {
            state.header.leftButtons = header.leftButtons;
            state.header.title = header.title;
            state.header.showBack = false;
            if (header.showBack) {
                state.header.showBack = header.showBack;
            }
            if (header.onBack) {
                state.header.onBack = header.onBack;
            }
            if (header.rightButtons && header.rightButtons.length > 0) {
                state.header.rightButtons = header.rightButtons;
            }
        },
        showHalfMenu(state) {
            state.isShowHalfMenu = true;
        },
        showFullMenu(state) {
            state.isShowFullMenu = true;
        },
        hideMenu(state) {
            state.isShowHalfMenu = false;
            state.isShowFullMenu = false;
        },
        getAppState(state) {
            try {
                repository
                    .getAppState({
                        screenid: state.screenId
                    })
                    .then((res) => {
                        const { data } = res;
                        if (data.Code === 200) {
                            state.menus = data.Data.menus;
                            state.user = data.Data.user;
                            state.messageCount = data.Data.message_count;
                            state.permissions = data.Data.permissions;
                            //
                            if (data.Data.permissions.usetype == 0) {
                                if (
                                    !/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
                                        navigator.userAgent
                                    ) &&
                                    Router.currentRoute._value.path.indexOf(
                                        '/mobile/'
                                    ) < -1
                                ) {
                                    Router.push(data.Data.permissions.URL);
                                }
                            }
                        }
                    });
            } catch (e) {
                console.log('Action getAppState: ' + e.message);
            }
        },
        resetAppState(state) {
            try {
                state.menus = [];
                state.user = {};
                state.messageCount = 0;
            } catch (e) {
                console.log('Action getAppState: ' + e.message);
            }
        },
        setScreenId(state, id) {
            state.screenId = id;
        },
        setNoLoading(state, val) {
            state.isNoLoading = val;
        },
        increaseCountLoading(state) {
            state.countLoading += 1;
        },
        decreaseCountLoading(state) {
            state.countLoading -= 1;
            if (state.countLoading < 0) {
                state.countLoading = 0;
            }
        },
        setMobile(state, isMobile) {
            state.isMobile = isMobile;
        },
        setBackgroundColorHeader(state, isBgHeaderDefault) {
            state.isBgHeaderDefault = isBgHeaderDefault;
        },
        setDataScreenChange(state, data) {
            state.isDataScreenChange = data;
        },
        setLogout(state, data) {
            state.isLogout = data;
        },
        setLogin(state, data) {
            state.isLogin = data;
        }
    },
    actions: {
        showLoading(context) {
            context.commit('showLoading');
        },
        hideLoading(context) {
            context.commit('hideLoading');
        },
        showForceLoading(context) {
            context.commit('showForceLoading');
        },
        hideForceLoading(context) {
            context.commit('hideForceLoading');
        },
        showHeaderError(context, errors) {
            context.commit('showHeaderError', errors);
        },
        hideHeaderError(context) {
            context.commit('hideHeaderError');
        },
        showModalMessage(context, message) {
            context.commit('showModalMessage', message);
        },
        hideModalMessage(context) {
            context.commit('hideModalMessage');
        },
        updateShowModalMessage(context, val) {
            context.commit('updateShowModalMessage', val);
        },
        setHeader(context, header) {
            context.commit('setHeader', header);
        },
        showHalfMenu(context) {
            context.commit('showHalfMenu');
        },
        showFullMenu(context) {
            context.commit('showFullMenu');
        },
        hideMenu(context) {
            context.commit('hideMenu');
        },
        getAppState(context) {
            context.commit('getAppState');
        },
        resetAppState(context) {
            context.commit('resetAppState');
        },
        setScreenId(context, id) {
            context.commit('setScreenId', id);
            if (localStorage.getItem('token')) {
                context.commit('getAppState');
            }
        },
        setNoLoading(context, val) {
            context.commit('setNoLoading', val);
        },
        increaseCountLoading(context) {
            context.commit('increaseCountLoading');
        },
        decreaseCountLoading(context) {
            context.commit('decreaseCountLoading');
        },
        setMobile(context, isMobile) {
            context.commit('setMobile', isMobile);
        },
        setBackgroundColorHeader(context, isBgHeaderDefault) {
            context.commit('setBackgroundColorHeader', isBgHeaderDefault);
        },
        setDataScreenChange(context, data) {
            context.commit('setDataScreenChange', data);
        },
        setLogout(context, data) {
            context.commit('setLogout', data);
        },
        setLogin(context, data) {
            context.commit('setLogin', data);
        }
    }
};
